

































































































































// Libraries
import { Component, Prop, Vue } from 'vue-property-decorator'

// Types
import { MatchConfigViewModel } from '@/types/view-models/match-config'

@Component
export default class MatchConfigCustomisationForm extends Vue {
  @Prop() readonly configVM!: MatchConfigViewModel
  @Prop() readonly errors!: { [key: string]: string[] }
  @Prop() readonly latestPresetName!: string
}
